import { VdsSidenav, VdsSidenavItem } from '@volt/volt-extended-components-react';
import styles from './SideNav.module.scss';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '@customer/store/hooks';
import { navLinksPrimary, navLinksSecondary } from '@customer/navigation';
import { useCallback, useState } from 'react';
import SideNavLinks from '../side-nav-links/SideNavLinks';
import SiteSwitcher from '../site-switcher/SiteSwitcher';

export function SideNav() {
  const { t } = useTranslation();

  const userData = useAppSelector(state => state.auth);

  const [isOpen, setIsOpen] = useState(false);

  const toggleIsOpen = useCallback(() => {
    setIsOpen(isOpen => !isOpen);
  }, []);

  return (
    <VdsSidenav
      showBrand={true}
      isAdaptable={false}
      expanded={isOpen && userData.isLoggedIn}
      mode="side"
    >
      <div slot="drawer" className={styles.sidenav}>
        <div className={styles.mainMenu}>
          <SideNavLinks isOpen={isOpen} links={navLinksPrimary} />
          <div className={styles.divider} />
          <SideNavLinks isOpen={isOpen} links={navLinksSecondary} />
        </div>

        <div className={styles.spacer} />

        <SiteSwitcher isOpen={isOpen} />

        <VdsSidenavItem
          key="sidenav-expando"
          icon={isOpen ? 'chevron-left' : 'chevron-right'}
          expanded={isOpen}
          value={t('CollapseMenu')}
          isActive={false}
          onClick={toggleIsOpen}
        />
      </div>
    </VdsSidenav>
  );
}

export default SideNav;
